import Layout from "../components/layout";
import * as React from "react";
import {FaExternalLinkAlt} from "react-icons/fa";


const GeschenkePage = () => {
  return (
    <Layout title={'Geschenkideen'}>
      <section className="p-8 flex flex-col items-center">
        <p className={'text-center mt-0'}>Hier geht's zu den Fotos:</p>
        <a className={"font-medium rounded text-white bg-primary p-2 w-96 max-w-xl flex gap-2 items-center justify-center"}
           href={'https://www.alina-atzler.de/Lauraundjohannes'} rel={'noreferrer'} target={'_blank'}>
          Fotos<FaExternalLinkAlt/>
        </a>
      </section>
    </Layout>
  )
}

export default GeschenkePage
